var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "search-session bg-white" }, [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-lg-4 col-md-4 col-sm-6" },
        [
          _c(
            "b-input-group",
            [
              _c("b-form-input", {
                staticClass: "placeholder-italic",
                attrs: {
                  type: "text",
                  placeholder: "Search by client or people",
                  formatter: _vm.format
                },
                on: { change: _vm.onSearchClients },
                model: {
                  value: _vm.textSearch,
                  callback: function($$v) {
                    _vm.textSearch = $$v
                  },
                  expression: "textSearch"
                }
              }),
              _vm._v(" "),
              _c("Icon", {
                staticClass: "search-icon",
                attrs: { name: "search" }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "search-icon" })
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6344196d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6344196d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/commons/SearchSession.vue
// module id = 1577
// module chunks = 1